import React, { useEffect } from 'react';
import { DefaultLayout } from '../layout/DefaultLayout';
import Banner from '../components/molecules/Banner';
import { topicE3, topicE4 } from '../data-references';
import { useTranslate } from '@tolgee/react';
import { asset } from 'lincd/lib/utils/LinkedFileStorage';
import { useProfileCompleted } from '../hooks/useProfileCompleted';
import Headline from '../components/atoms/Headline';
import ActionContent from '../components/molecules/ActionContent';
import './UnityEvent.scss';
import style from './UnityEvent.scss.json';
import ShareActionDetails from '../components/molecules/ShareActionDetails';
import { useAuth } from 'lincd-auth/lib/hooks/useAuth';
import { Player } from 'lincd-irlcg/lib/shapes/Player';
import { UserAccount } from 'profile-plus/lib/shapes/UserAccount';

const UnityEvent = () => {
  let topic = topicE3;
  let { t } = useTranslate();
  const { checkIsCompleted } = useProfileCompleted();
  const auth = useAuth<Player, UserAccount>();
  const user = auth.user;

  // check if user has completed profile setup
  useEffect(() => {
    checkIsCompleted();
  }, []);

  //with t(key,defaultValue) the key will show up on in the dev context app (hover text and hold Option) and can be added and translated in tolgee.
  let prefix = 'topic' + topic.identifier;
  return (
    <DefaultLayout backgroundColor={'white'}>
      <Banner
        title={t(prefix + '.title', topic.name)}
        subtitle={t(prefix + '.subTitle', topic.description)}
        image={asset('/images/banners/unitybanner_2.webp')}
      />

      <div className={style.content}>
        <p>
          <span className={style.bold}>
            {user?.attendance === 'home'
              ? t(
                  prefix + '.action.homeText',
                  "Reach out to Rotarians from other districts or countries. Learn about each other's clubs and what you share in common.",
                )
              : t(
                  prefix + '.action.inPersonText',
                  "Reach out to Rotarians from other countries at the convention. Learn about each other's club successes and discover what you share in common.",
                )}
          </span>
        </p>

        <ActionContent
          subtitle={t('word.howToKeepScore', 'How to Keep Score')}
          content={
            <>
              <p>
                <p>
                  <span className={style.bold}>
                    {t(
                      prefix + '.plan.subtitle',
                      'Celebrating our Common Humanity',
                    )}
                  </span>
                  :{' '}
                  {t(
                    prefix + '.plan.subtitleText',
                    'Each person you meet with from another district or country counts as 1 Peace Action.',
                  )}
                  <br />
                  <br />
                  <span className={style.underline}>
                    {t('word.bronzePeaceMedal', 'Bronze Peace Medal')}
                  </span>
                  :{' '}
                  <span className={style.bold}>
                    {t(prefix + '.plan.bronzePeaceMedalText1', '1 - 3')}
                  </span>{' '}
                  {t(prefix + '.plan.bronzePeaceMedalText2', 'people.')}{' '}
                  <span className={style.blue}>
                    (
                    {t(
                      prefix + '.plan.bronzePeaceMedalText3',
                      '1-3 Peace Actions',
                    )}
                    )
                  </span>
                  <br />
                  <br />
                  <span className={style.underline}>
                    {' '}
                    {t('word.silverPeaceMedal', 'Silver Peace Medal')}
                  </span>
                  :{' '}
                  <span className={style.bold}>
                    {t(prefix + '.plan.silberPeaceMedalText1', '4 - 6')}
                  </span>{' '}
                  {t(prefix + '.plan.silverPeaceMedalText2', 'people.')}
                  {'  '}
                  <span className={style.blue}>
                    (
                    {t(
                      prefix + '.plan.silverPeaceMedalText3',
                      '4-6 Peace Actions',
                    )}
                    )
                  </span>
                  <br />
                  <br />
                  <span className={style.underline}>
                    {t('word.goldPeaceMedal', 'Gold Peace Medal')}
                  </span>
                  :{' '}
                  <span className={style.bold}>
                    {t(prefix + '.plan.goldPeaceMedalText1', '7 or more')}
                  </span>{' '}
                  {t(prefix + '.plan.goldPeaceMedalText2', 'people')}{' '}
                  <span className={style.blue}>
                    (
                    {t(
                      prefix + '.plan.goldPeaceMedalText3',
                      '7+ Peace Actions',
                    )}
                    )
                  </span>
                </p>
              </p>
            </>
          }
        />
        <Headline
          subtitle={t('word.peaceactionresults', 'Peace Action Results')}
          lined="black"
        />
      </div>
      <ShareActionDetails
        topic={topic}
        currentTopic={topicE3}
        nextTopic={topicE4}
        type="event"
      />
    </DefaultLayout>
  );
};

export default UnityEvent;
